import React, { useState, useEffect } from 'react';
import { Button, Card, CardHeader, CardBody, FormGroup, Form, Input, Container, Row, Col, InputGroup, InputGroupAddon } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faEye, faEyeSlash, faUser, faCog } from '@fortawesome/free-solid-svg-icons';
import {api} from '../../../../api';
import Cookies from 'js-cookie';
import Tippy from '@tippyjs/react';

const getProfileImagePath = (imageName) => {
  if (!imageName) return null;
  return `${process.env.REACT_APP_API_URL}/dashboard/images/${imageName}`;
};

const Profile3 = () => {
  
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPasswordForm, setShowPasswordForm] = useState(false);

  const [formData, setFormData] = useState({
    emp_id: "", // not hardcoded
    emp_name: '',
    email: '',
    phoneno: '',
    dob: '',
    role: '',
    salary: '',
    address: '',
    image: ''
  });

  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [showPasswords, setShowPasswords] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false
  });
  const cookieId = Cookies.get('token');
  const [updateStatus, setUpdateStatus] = useState({ type: '', message: '' });
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch company_id and emp_id from cookies
        const company_id = Cookies.get('company_id');
        const emp_id = Cookies.get('emp_id');
        if (!company_id || !emp_id) {
          throw new Error('Missing company_id or emp_id in cookies');
        }
        const response = await api.get(`PMprofileView.php?company_id=${company_id}&emp_id=${emp_id}`);
        setTasks(response.data);
        setFormData({
          emp_id: response.data.emp_id,
          emp_name: response.data.emp_name,
          email: response.data.email,
          phoneno: response.data.phoneno,
          dob: response.data.dob,
          role: response.data.role,
          salary: response.data.salary,
          address: response.data.address,
          image: response.data.profile_image
        });
        if (response.data.profile_image) {
          setProfileImage(getProfileImagePath(response.data.profile_image));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  
  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    
    const company_id = Cookies.get('company_id');
    if (!company_id) {
      setSuccessMessage('Company ID not found. Please log in again.');
      setShowSuccessAlert(true);
      return;
    }
    
    const formDataToSend = new FormData();
    formDataToSend.append('company_id', company_id);
    formDataToSend.append('username', formData.emp_name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('id', formData.emp_id);
    formDataToSend.append('phoneno', formData.phoneno);
    formDataToSend.append('dob', formData.dob);
    formDataToSend.append('salary', formData.salary);
    formDataToSend.append('role', formData.role);
    formDataToSend.append('address', formData.address);
    formDataToSend.append('image', formData.image);

    try {
      const response = await api.post("pmProfileUpdate.php", formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data && response.data.status === 'success') {
        setSuccessMessage('Profile updated successfully!');
        setShowSuccessAlert(true);
      } else {
        setSuccessMessage(response.data.message || 'Failed to update profile. Please try again.');
        setShowSuccessAlert(true);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      setSuccessMessage(error.response?.data?.message || 'Error updating profile. Please try again.');
      setShowSuccessAlert(true);
    }
  };

  // Function to handle form input changes
  const handleInputChange = (event) => {
    const {name, value}  = event.target
    setFormData({
      ...formData,
      [event.target.name]: event.target.value
    });
    console.log(formData);
  };

  // Function to handle password input changes
  const handlePasswordChange = (event) => {
    const { name, value } = event.target;
    setPasswordData({
      ...passwordData,
      [name]: value
    });
  };

  // Function to toggle password visibility
  const togglePasswordVisibility = (field) => {
    setShowPasswords({
      ...showPasswords,
      [field]: !showPasswords[field]
    });
  };

  const [inputValue, setInputValue] = useState("");
  const [profileImage, setProfileImage] = useState(null);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file));
      setFormData({ ...formData, image: event.target.files[0] });
    }
  };

  const handleCancelUpload = () => {
    setProfileImage(null);
    document.getElementById('input-profile-image').value = '';
  };

  // Function to handle password change submission
  const handlePasswordSubmit = async (event) => {
    event.preventDefault();
    
    const company_id = Cookies.get('company_id');
    if (!company_id) {
      setSuccessMessage('Company ID not found. Please log in again.');
      setShowSuccessAlert(true);
      return;
    }

    // Validate password fields
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setSuccessMessage('New password and confirm password do not match.');
      setShowSuccessAlert(true);
      return;
    }

    if (passwordData.newPassword.length < 6) {
      setSuccessMessage('Password must be at least 6 characters long.');
      setShowSuccessAlert(true);
      return;
    }

    try {
      const response = await api.post("changePassword.php", {
        emp_id: formData.emp_id,
        company_id: company_id,
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
        confirmPassword: passwordData.confirmPassword
      });

      if (response.data && response.data.status === 'success') {
        setSuccessMessage('Password updated successfully!');
        setShowSuccessAlert(true);
        // Clear password fields
        setPasswordData({
          currentPassword: '',
          newPassword: '',
          confirmPassword: ''
        });
        setShowPasswordForm(false);
      } else {
        setSuccessMessage(response.data.message || 'Failed to update password. Please try again.');
        setShowSuccessAlert(true);
      }
    } catch (error) {
      console.error("Error updating password:", error);
      setSuccessMessage(error.response?.data?.message || 'Error updating password. Please try again.');
      setShowSuccessAlert(true);
    }
  };

  return (
    <>
      {/* Original Header Section */}
      <div
        className="header pb-8 pt-5 pt-lg-8 d-flex align-items-center"
        style={{
          minHeight: "400px",
          backgroundImage:
            "url(" + require("../../assets/img/theme/profile-cover.jpg") + ")",
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        {/* Mask */}
        <span className="mask bg-gradient-default opacity-8" />
        {/* Header container */}
        <Container className="d-flex align-items-center" fluid>
          <Row>
            <Col lg="10" md="10">
              <h1 className="display-2" style={{ color: 'black' }}>Hello {tasks.emp_name}</h1>
              <p className="mt-10 mb-5" style={{ color: 'black' }}>
                This is your profile page. Where you can see your Profile Details
                and let us know your changes
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Main Content */}
      <Container className="mt--7 mb--5" fluid>
        <Row>
          <Col lg="10" md="12" className="mx-auto">
            <Card style={{
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              backgroundColor: '#fff',
              borderRadius: '15px',
              border: '2px solid #e9ecef',
              overflow: 'hidden'
            }}>
              <CardBody style={{ padding: '40px' }} className="card-padding">
                
                {/* Profile Image Section */}
                <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                  <div style={{
                    width: '150px',
                    height: '150px',
                    border: '2px solid black',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    margin: '0 auto 25px',
                    boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                    position: 'relative'
                  }} className="profile-image">
                    {profileImage ? (
                      <img
                        src={profileImage}
                        alt="Profile"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : tasks.profile_image ? (
                      <img
                        src={window.location.hostname === 'localhost' 
                          ? require(`../../../images/${tasks.profile_image}`)
                          : `/images/${tasks.profile_image}`}
                        alt="Profile"
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover'
                        }}
                      />
                    ) : (
                      <div style={{
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '72px',
                        color: '#d86f89'
                      }}>
                        <FontAwesomeIcon icon={faUser} />
                      </div>
                    )}
                  </div>
                  
                  {/* Upload Button */}
                  <Button
                    style={{
                      backgroundColor: '#d86f89',
                      borderColor: '#d86f89',
                      color: 'black',
                      borderRadius: '25px',
                      padding: '10px 25px',
                      fontSize: '14px'
                    }}
                    onClick={() => document.getElementById('input-profile-image').click()}
                  >
                    <FontAwesomeIcon icon={faPencilAlt} style={{ marginRight: '8px' }} />
                    Upload Photo
                  </Button>
                  <Input
                    type="file"
                    id="input-profile-image"
                    accept="image/*"
                    onChange={handleFileUpload}
                    style={{ display: 'none' }}
                  />
                </div>

                {/* Profile Details Form */}
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg="6" md="6" sm="12" className="mb-3">
                      <FormGroup>
                        <label style={{ 
                          fontWeight: 'bold', 
                          color: '#333', 
                          marginBottom: '8px', 
                          fontSize: '16px'
                        }}>
                          Name:
                        </label>
                        <Input
                          style={{
                            border: '2px solid #e9ecef',
                            borderRadius: '8px',
                            padding: '12px 15px',
                            fontSize: '14px'
                          }}
                          placeholder="Enter name"
                          type="text"
                          name="emp_name"
                          defaultValue={tasks.emp_name}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6" sm="12" className="mb-3">
                      <FormGroup>
                        <label style={{ 
                          fontWeight: 'bold', 
                          color: '#333', 
                          marginBottom: '8px', 
                          fontSize: '16px'
                        }}>
                          Email ID:
                        </label>
                        <Input
                          style={{
                            border: '2px solid #e9ecef',
                            borderRadius: '8px',
                            padding: '12px 15px',
                            fontSize: '14px'
                          }}
                          placeholder="Enter email"
                          type="email"
                          name="email"
                          defaultValue={tasks.email}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup>
                        <label style={{ 
                          fontWeight: 'bold', 
                          color: '#333', 
                          marginBottom: '8px', 
                          fontSize: '16px'
                        }}>
                          Mobile No:
                        </label>
                        <Input
                          style={{
                            border: '2px solid #e9ecef',
                            borderRadius: '8px',
                            padding: '12px 15px',
                            fontSize: '14px'
                          }}
                          placeholder="Enter mobile"
                          type="tel"
                          name="phoneno"
                          defaultValue={tasks.phoneno}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup>
                        <label style={{ 
                          fontWeight: 'bold', 
                          color: '#333', 
                          marginBottom: '8px', 
                          fontSize: '16px'
                        }}>
                          DOB:
                        </label>
                        <Input
                          style={{
                            border: '2px solid #e9ecef',
                            borderRadius: '8px',
                            padding: '12px 15px',
                            fontSize: '14px'
                          }}
                          placeholder="Date of birth"
                          type="date"
                          name="dob"
                          defaultValue={tasks.dob}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup>
                        <label style={{ 
                          fontWeight: 'bold', 
                          color: '#333', 
                          marginBottom: '8px', 
                          fontSize: '16px'
                        }}>
                          Role:
                        </label>
                        <Input
                          style={{
                            border: '2px solid #e9ecef',
                            borderRadius: '8px',
                            padding: '12px 15px',
                            fontSize: '14px'
                          }}
                          placeholder="Enter role"
                          type="text"
                          name="role"
                          defaultValue={tasks.role}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                    <Col lg="6" md="6" sm="12">
                      <FormGroup>
                        <label style={{ 
                          fontWeight: 'bold', 
                          color: '#333', 
                          marginBottom: '8px', 
                          fontSize: '16px'
                        }}>
                          Salary:
                        </label>
                        <Input
                          style={{
                            border: '2px solid #e9ecef',
                            borderRadius: '8px',
                            padding: '12px 15px',
                            fontSize: '14px'
                          }}
                          placeholder="Enter salary"
                          type="number"
                          name="salary"
                          defaultValue={tasks.salary}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12">
                      <FormGroup>
                        <label style={{ 
                          fontWeight: 'bold', 
                          color: '#333', 
                          marginBottom: '8px', 
                          fontSize: '16px'
                        }}>
                          Address:
                        </label>
                        <Input
                          style={{
                            border: '2px solid #e9ecef',
                            borderRadius: '8px',
                            padding: '12px 15px',
                            fontSize: '14px'
                          }}
                          placeholder="Enter address"
                          type="textarea"
                          rows="4"
                          name="address"
                          defaultValue={tasks.address}
                          onChange={handleInputChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  
                  {/* Action Buttons */}
                  <Row style={{ marginTop: '30px' }}>
                    <Col lg="6" md="6" sm="12" className="mb-3">
                      <Button
                        style={{
                          backgroundColor: '#d86f89',
                          borderColor: '#d86f89',
                          color: 'black',
                          borderRadius: '25px',
                          padding: '12px 30px',
                          width: '100%',
                          fontSize: '16px',
                          fontWeight: 'bold'
                        }}
                        type="submit"
                      >
                        Edit Details
                      </Button>
                    </Col>
                    <Col lg="6" md="6" sm="12" className="mb-3">
                      <Button
                        style={{
                          backgroundColor: '#6c757d',
                          borderColor: '#6c757d',
                          color: 'white',
                          borderRadius: '25px',
                          padding: '12px 30px',
                          width: '100%',
                          fontSize: '16px',
                          fontWeight: 'bold'
                        }}
                        onClick={() => setShowPasswordForm(true)}
                      >
                        Change Password
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Password Change Form Modal */}
        {showPasswordForm && (
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex',
            justifyContent: 'center', alignItems: 'center', zIndex: 9999,
            backdropFilter: 'blur(5px)'
          }}>
            <div style={{
              backgroundColor: '#fff', padding: '40px', borderRadius: '15px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.3)', 
              maxWidth: '500px', width: '90%', border: '3px solid #d86f89'
            }}>
                              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                  <h3 style={{ color: '#333', marginBottom: '10px' }}>Change Password</h3>
                  <p style={{ color: '#6c757d', fontSize: '14px' }}>Update your password securely</p>
                </div>

              <Form onSubmit={handlePasswordSubmit}>
                <FormGroup>
                  <label style={{ 
                    fontWeight: 'bold', 
                    color: '#333', 
                    marginBottom: '8px', 
                    fontSize: '16px'
                  }}>
                    Current Password:
                  </label>
                  <InputGroup>
                                          <Input
                        style={{
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          padding: '12px 15px',
                          fontSize: '14px'
                        }}
                        placeholder="Enter current password"
                        type={showPasswords.currentPassword ? "text" : "password"}
                        name="currentPassword"
                        value={passwordData.currentPassword}
                        onChange={handlePasswordChange}
                      />
                    <InputGroupAddon addonType="append">
                      <Button
                        type="button"
                        style={{
                          backgroundColor: 'transparent',
                          border: '2px solid #e9ecef',
                          borderLeft: 'none',
                          color: '#6c757d',
                          borderRadius: '0 8px 8px 0',
                          padding: '12px 15px'
                        }}
                        onClick={() => togglePasswordVisibility('currentPassword')}
                      >
                        <FontAwesomeIcon icon={showPasswords.currentPassword ? faEyeSlash : faEye} />
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>

                <FormGroup>
                  <label style={{ 
                    fontWeight: 'bold', 
                    color: '#333', 
                    marginBottom: '8px', 
                    fontSize: '16px'
                  }}>
                    New Password:
                  </label>
                  <InputGroup>
                                          <Input
                        style={{
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          padding: '12px 15px',
                          fontSize: '14px'
                        }}
                        placeholder="Enter new password"
                        type={showPasswords.newPassword ? "text" : "password"}
                        name="newPassword"
                        value={passwordData.newPassword}
                        onChange={handlePasswordChange}
                      />
                    <InputGroupAddon addonType="append">
                      <Button
                        type="button"
                        style={{
                          backgroundColor: 'transparent',
                          border: '2px solid #e9ecef',
                          borderLeft: 'none',
                          color: '#6c757d',
                          borderRadius: '0 8px 8px 0',
                          padding: '12px 15px'
                        }}
                        onClick={() => togglePasswordVisibility('newPassword')}
                      >
                        <FontAwesomeIcon icon={showPasswords.newPassword ? faEyeSlash : faEye} />
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>

                <FormGroup>
                  <label style={{ 
                    fontWeight: 'bold', 
                    color: '#333', 
                    marginBottom: '8px', 
                    fontSize: '16px'
                  }}>
                    Confirm Password:
                  </label>
                  <InputGroup>
                                          <Input
                        style={{
                          border: '2px solid #e9ecef',
                          borderRadius: '8px',
                          padding: '12px 15px',
                          fontSize: '14px'
                        }}
                        placeholder="Confirm new password"
                        type={showPasswords.confirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        value={passwordData.confirmPassword}
                        onChange={handlePasswordChange}
                      />
                    <InputGroupAddon addonType="append">
                      <Button
                        type="button"
                        style={{
                          backgroundColor: 'transparent',
                          border: '2px solid #e9ecef',
                          borderLeft: 'none',
                          color: '#6c757d',
                          borderRadius: '0 8px 8px 0',
                          padding: '12px 15px'
                        }}
                        onClick={() => togglePasswordVisibility('confirmPassword')}
                      >
                        <FontAwesomeIcon icon={showPasswords.confirmPassword ? faEyeSlash : faEye} />
                      </Button>
                    </InputGroupAddon>
                  </InputGroup>
                </FormGroup>

                <Row style={{ marginTop: '30px' }}>
                  <Col lg="6" md="6" sm="12" className="mb-3">
                    <Button
                      style={{
                        backgroundColor: '#d86f89',
                        borderColor: '#d86f89',
                        color: 'black',
                        borderRadius: '25px',
                        padding: '12px 25px',
                        width: '100%',
                        fontSize: '16px',
                        fontWeight: 'bold'
                      }}
                      type="submit"
                    >
                      Change Password
                    </Button>
                  </Col>
                  <Col lg="6" md="6" sm="12" className="mb-3">
                    <Button
                      style={{
                        background: 'linear-gradient(135deg, #6c757d, #8e9aaf)',
                        border: 'none',
                        color: 'white',
                        borderRadius: '30px',
                        padding: '12px 25px',
                        width: '100%',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '0 6px 20px rgba(108, 117, 125, 0.3)',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = '0 8px 25px rgba(108, 117, 125, 0.4)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = '0 6px 20px rgba(108, 117, 125, 0.3)';
                      }}
                      onClick={() => {
                        setShowPasswordForm(false);
                        setPasswordData({
                          currentPassword: '',
                          newPassword: '',
                          confirmPassword: ''
                        });
                      }}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        )}
      </Container>

      {/* Success Alert Modal */}
      {showSuccessAlert && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex',
          justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999,
          backdropFilter: 'blur(5px)'
        }}>
          <div style={{
            backgroundColor: '#fff', padding: '40px', borderRadius: '20px',
            boxShadow: '0 20px 40px rgba(216, 111, 137, 0.3)', textAlign: 'center',
            maxWidth: '400px', width: '90%', border: '3px solid #d86f89',
            animation: 'slideIn 0.3s ease-out'
          }}>
            <div style={{ 
              fontSize: '64px', 
              color: '#d86f89', 
              marginBottom: '20px',
              animation: 'bounce 0.6s ease-in-out'
            }}>✓</div>
            <h4 style={{ color: '#28a745', marginBottom: '15px', fontWeight: 'bold' }}>Success!</h4>
            <p style={{ color: '#333', fontSize: '16px', marginBottom: '30px' }}>{successMessage}</p>
            <Button
              style={{
                background: 'linear-gradient(135deg, #d86f89, #ff8fa3)',
                border: 'none',
                color: 'white',
                padding: '12px 30px',
                borderRadius: '25px',
                fontSize: '16px',
                fontWeight: 'bold',
                boxShadow: '0 6px 20px rgba(216, 111, 137, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 8px 25px rgba(216, 111, 137, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 6px 20px rgba(216, 111, 137, 0.3)';
              }}
              onClick={() => {
                setShowSuccessAlert(false);
                window.location.reload();
              }}
            >OK</Button>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }

        @media (max-width: 768px) {
          .profile-image {
            width: 120px !important;
            height: 120px !important;
          }
          
          .card-padding {
            padding: 20px !important;
          }
          
          .button-responsive {
            padding: 12px 20px !important;
            font-size: 14px !important;
          }
        }

        @media (max-width: 576px) {
          .profile-image {
            width: 100px !important;
            height: 100px !important;
          }
          
          .card-padding {
            padding: 15px !important;
          }
        }
      `}</style>
    </>
  );
};

export default Profile3;